import ExperienceSearchCategoryResults from 'components/Experiences/ExperiencesSearch/ExperienceSearchBar/ExperienceSearchCategoryResults'
import React, { useId } from 'react'
import SearchFloatingPanel from './SearchFloatingPanel'
import noop from 'lib/function/noop'
import { useIntl } from 'react-intl'

interface Props {
  open?: boolean
  onClose?: () => void
}

function ExperienceCategoryPanel(props: Props) {
  const { open, onClose = noop } = props
  const formId = useId()
  const intl = useIntl()

  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    onClose()
  }

  const title = intl.formatMessage({
    id: 'okKNGuxyf_-QCIWYtQP_',
    defaultMessage: 'What are you interested in?',
    description: 'Heading title for experience category selection panel',
  })

  const applyText = intl.formatMessage({
    id: 'R7QdmHHlcVvudq7qyDFI',
    defaultMessage: 'Apply',
    description: 'Button text to apply selected experience categories',
  })

  return (
    <SearchFloatingPanel
      isOpen={open}
      onClose={onClose}
      onGoBack={onClose}
      onConfirm={onClose}
      title={title}
      confirmText={applyText}
    >
      <form onSubmit={onSubmit} id={formId}>
        <ExperienceSearchCategoryResults />
      </form>
    </SearchFloatingPanel>
  )
}

export default ExperienceCategoryPanel
